import ClickableListItem from 'LuxKit/List/ClickableListItem'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'

const Container = styled.div`
  display: grid;
  grid-template: "content" auto / 1fr;
  gap: ${rem(16)};
  padding-top: ${rem(24)};

  ${mediaQueryUp.tablet} {
    grid-template: "nav content" 1fr / ${rem(248)} minmax(0, 1fr);
  }
`

const Nav = styled.div`
  grid-area: nav;
  display: none;

  ${mediaQueryUp.tablet} {
    display: block;
  }
`

const StickyNavContent = styled.div`
  position: sticky;
  top: ${rem(24)};
`

const Content = styled.div`
  grid-area: content;
  padding-bottom: ${rem(48)};
`

const SectionGroup = styled.div`
  margin-bottom: ${rem(16)};
`

const SectionHeader = styled.div`
  padding: ${rem(12)} ${rem(16)};
  font-weight: 600;
  font-size: ${rem(14)};
  text-transform: uppercase;
  color: #333;
`

const SubsectionItem = styled(ClickableListItem)`
  padding-left: ${rem(24)};
  text-transform: capitalize;
`

interface FaqSection {
  id: string
  sidebarTitle: string
}

interface FaqSidebarSection {
  title: string
  items: Array<FaqSection>
}

interface Props {
  sections: Array<FaqSidebarSection>
  children: React.ReactNode
}

function FaqSidebar(props: Props) {
  const { sections, children } = props

  const handleScrollTo = (sectionId: string) => (e: React.MouseEvent) => {
    e.preventDefault()
    const element = document.getElementById(sectionId)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  return (
    <Container>
      <Content>{children}</Content>
      <Nav>
        <StickyNavContent>
          {sections.map((section) => (
            <SectionGroup key={section.title}>
              <SectionHeader>{section.title}</SectionHeader>
              {section.items.map((item) => (
                <SubsectionItem
                  key={item.id}
                  role="menuitem"
                  to={`#${item.id}`}
                  title={item.sidebarTitle}
                  size="medium"
                  onClick={handleScrollTo(item.id)}
                />
              ))}
            </SectionGroup>
          ))}
        </StickyNavContent>
      </Nav>
    </Container>
  )
}

export default FaqSidebar
